import { render, staticRenderFns } from "./CourseManager.vue?vue&type=template&id=3c8157e3&scoped=true&"
import script from "./CourseManager.vue?vue&type=script&lang=js&"
export * from "./CourseManager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c8157e3",
  null
  
)

export default component.exports